import React, { FunctionComponent, Ref } from 'react';

import styled from 'styled-components';

import { colors, values } from 'chime-ui/system';

const Icon = styled.svg.attrs({
  viewBox: '0 0 14 11',
  children: (
    <path d="M13.5474 1.51224L5.54784 10.0451.501953 5.55984 1.4985 4.43873l3.95411 3.51476L12.4531.486328l1.0943 1.025912z" />
  ),
})`
  fill: ${colors.white};
`;

const StyledCheckbox = styled.span`
  position: relative;
  cursor: default;
  display: inline-block;
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  background: ${({ checked }) => (checked ? colors.darkGreen : colors.white)};
  border: solid 2px ${colors.darkGreen};
  border-radius: 0.25rem;
  margin-right: 1.125rem;
  transition: all ${values.TIMEOUT_DELAY}s;
`;

const StyledCustomCheckboxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  cursor: inherit;
`;

const StyledLabel = styled.label`
  display: flex;
  margin-bottom: 1rem;

  a {
    font-weight: 700;

    &:hover,
    &:focus {
      outline: none;
      color: ${colors.notBlack};
    }

    &:active,
    &:visited {
      color: inherit;
    }
  }
`;

type CheckboxType = {
  defaultChecked: boolean;
  ref?: Ref<HTMLInputElement>;
  onChange?: React.ChangeEventHandler;
};

type CheckboxProps = CheckboxType & React.HTMLProps<HTMLInputElement>;

const ForwardedCheckbox: FunctionComponent<CheckboxProps> = React.forwardRef(
  function Checkbox(
    { defaultChecked = false, onChange, children, ...props },
    ref
  ) {
    const [checkedState, setChecked] = React.useState(defaultChecked);

    const handleOnChange = event => {
      setChecked(event.target.checked);

      onChange?.(event);
    };

    return (
      <StyledLabel>
        <StyledCheckbox checked={checkedState}>
          <StyledCustomCheckboxInput
            type="checkbox"
            defaultChecked={defaultChecked}
            onChange={handleOnChange}
            {...props}
            ref={ref}
          />
          <Icon />
        </StyledCheckbox>
        {children}
      </StyledLabel>
    );
  }
);

export default ForwardedCheckbox;
